const localizers = {
  'Alerts.noAlerts.txt': () => `Pro tento report nejsou nastaveny žádné výstrahy`,
  'BirdImage.image.txt': () => `Obraz`,
  'ComboBox.clearFilter.txt': () => `Vymazat filtr`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (žádná data)`,
  'ContextMenu.selectAll.txt': () => `Vybrat vše`,
  'ContextMenu.clearSelection.txt': () => `Vymazat výběr`,
  'ContextMenu.exportImage.txt': () => `Exportovat jako obraz`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Vzestupně`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Sestupně`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Přidat vzestupně`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Přidat sestupně`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Odebrat ${role} z řazení`,
  'ContextMenu.removeSortLevel.txt': () => `Odebrat úroveň řazení`,
  'ContextMenu.sort.txt': () => `Řadit`,
  'ContextMenu.selectShortestPath.txt': () => `Vybrat nejkratší cestu`,
  'ContextMenu.explain.txt': () => `Vysvětlit data`,
  'ContextMenu.explainRole.txt': ({role}) => `Vysvětlit ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Spravovat sloupce`,
  'DrillableTooltip.drill.txt': () => `PŘECHOD`,
  'DrillableTooltip.tooltip.txt': () => `POPISEK`,
  'DrillableTooltip.links.txt': () => `ODKAZY`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Odkaz stránky na ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Odkaz reportu na ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Externí odkaz na ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Není k dispozici`,
  'Breadcrumb.all.fmt': ({label}) => `Všechny ${label}`,
  'BrowserCheck.title.txt': () => `Kontrola rozhraní WebGL`,
  'BrowserCheck.msg.txt': () => `Rozhraní WebGL je zakázáno nebo ho nepodporuje váš prohlížeč.   \nKliknutím na OK zobrazíte report v klasickém prohlížeči.`,
  'EmailUtil.subject.multiple.txt': () => `Reporty k revizi`,
  'EmailUtil.tooLongEmail.txt': () => `Limit délky e-mailu byl překročen. Vyberte méně reportů k odeslání e-mailem.`,
  'HiddenSectionDialog.close.txt': () => `Zavřít`,
  'HiddenSectionDialog.export.txt': () => `Exportovat jako PDF`,
  'InfoPanel.information.txt': () => `Informace`,
  'InfoPanel.comments.txt': () => `Komentáře`,
  'InfoPanel.alerts.txt': () => `Výstrahy`,
  'IncomingFilters.promptbars.txt': () => `Lišty s výzvou`,
  'Information.title.txt': () => `Nadpis`,
  'Information.name.txt': () => `Název:`,
  'Information.description.txt': () => `Popis:`,
  'Information.displayRules.txt': () => `Pravidla zobrazení:`,
  'Information.graphLevel.txt': () => `Úroveň grafu`,
  'Information.reportLevel.txt': () => `Úroveň reportu`,
  'Information.legend.txt': () => `Legenda`,
  'Information.incomingFilters.txt': () => `Příchozí filtry:`,
  'Information.noIncomingFilters.txt': () => `Žádné příchozí filtry`,
  'Information.dataSourceFilters.txt': () => `Filtry zdroje dat:`,
  'Information.interactiveFilters.txt': () => `Interaktivní filtry:`,
  'MobileContainer.mobileBIMessage.txt': () => `Přístup k reportům SAS na mobilním zařízení.`,
  'ObjectTypes.report.txt': () => `Report`,
  'ObjectTypes.Report.BI.txt': () => `Report SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored Process Report`,
  'ObjectTypes.StoredProcess.txt': () => `Uložený proces`,
  'MissingValues.label.txt': () => `(chybějící hodnoty)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Zrušit`,
  'PromptContainer.close.txt': () => `Zavřít`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Hodnota musí být číslo mezi ${min} a ${max}, včetně.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Specifikujte platnou číselnou hodnotu.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Hodnota není platná pro přidělená data`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Zadat: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Zadat: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Zadat ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} – ${max}`,
  'Slider.missingValues.txt': () => `Chybějící hodnoty`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Zpět`,
  'ReportContainer.reportCorrupted.txt': () => `REPORT JE POŠKOZENÝ`,
  'ReportContainer.themeLoadFailed.txt': () => `Nepodařilo se načíst motiv reportu.`,
  'ReportContainer.restoreButton.tip.txt': () => `Obnovit report`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Report obnoven`,
  'ReportContainer.renderError.txt': () => `Došlo k chybě. Report se nepodařilo zobrazit.`,
  'ReportContainer.component.renderError.txt': () => `Došlo k chybě. Komponentu nebylo možné vykreslit.`,
  'ReportContentPage.open.txt': () => `Otevřít...`,
  'ReportContentPage.refreshReport.txt': () => `Aktualizovat report`,
  'ReportContentPage.editReport.txt': () => `Upravit report`,
  'ReportContentPage.print.txt': () => `Tisk...`,
  'ReportContentPage.email.txt': () => `E-mail...`,
  'ReportContentPage.export.txt': () => `Export do Excelu...`,
  'ReportContentPage.reportProperties.txt': () => `Vlastnosti reportu`,
  'ReportContentPage.shareReport.txt': () => `Sdílet report`,
  'ReportContentPage.enableOverlays.txt': () => `Povolit překrývání objektů`,
  'ReportContentPage.disableOverlays.txt': () => `Zakázat překrývání objektů`,
  'ReportContentPage.link.txt': () => `Odkaz...`,
  'ReportContentPage.settings.txt': () => `Nastavení...`,
  'ReportContentPage.editPlayback.txt': () => `Upravit přehrávání`,
  'ReportContentPage.playReport.txt': () => `Přehrát report`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Zobrazit nabízené filtry`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Skrýt nabízené filtry`,
  'ReportContentPage.reportFilters.txt': () => `Úroveň reportu`,
  'ReportContentPage.pageFilters.txt': () => `Úroveň stránky`,
  'ReportContentPage.refreshRequired.txt': () => `Je požadována aktualizace reportu`,
  'ReportContentPage.infoButton.tip.txt': () => `Informační panel`,
  'ReportContentPage.backButton.tip.txt': () => `Zobrazit všechny reporty`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Další možnosti`,
  'ReportContentPage.itemGroupName.txt': () => `Reporty`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Maximalizovat report`,
  'ReportContentPage.closeButton.txt': () => `Zavřít report`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Report maximalizován`,
  'ReportContentPage.resetReportState.txt': () => `Obnovit výchozí stav reportu`,
  'ReportContentPage.summary.txt': () => `Zobrazit souhrn`,
  'ReportManagerPage.objectMenu.open.txt': () => `Otevřít`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Upravit`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Souhrn`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Vlastnosti`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-mail...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Tisk`,
  'ReportManagerPage.browseReportsButton.txt': () => `Procházet reporty`,
  'ReportManagerPage.newReportButton.txt': () => `Nový report`,
  'ReportManagerPage.emptyView.message.txt': () => `Nebyly nalezeny žádné reporty.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Procházet reporty`,
  'ReportManagerPage.tableView.name.txt': () => `Název`,
  'ReportManagerPage.tableView.author.txt': () => `Autor`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Naposledy modifikoval`,
  'ReportManagerPage.openButton.tip.txt': () => `Otevřít report`,
  'ReportManagerPage.emailButton.tip.txt': () => `Zaslat report e-mailem`,
  'ReportManagerPage.printButton.tip.txt': () => `Tisk reportu do PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Vlastnosti reportu`,
  'ReportObject.multipleReferences.error.txt': () => `Objekty reportu nelze použít ve více kontextech.`,
  'ReportObject.notFound.error.txt': () => `Název objektu nelze v určeném reportu najít.`,
  'ReportObject.invalidPage.error.txt': () => `Určená stránka je neplatná.`,
  'ReportPropertiesDialog.open.txt': () => `Otevřít`,
  'ReportPropertiesDialog.close.txt': () => `Zavřít`,
  'ReportPropertiesDialog.name.txt': () => `Název:`,
  'ReportPropertiesDialog.description.txt': () => `Popis:`,
  'ReportPropertiesDialog.keywords.txt': () => `Klíčová slova:`,
  'ReportPropertiesDialog.type.txt': () => `Typ:`,
  'ReportPropertiesDialog.location.txt': () => `Umístění:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Vytvořil/a:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Datum vytvoření:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Modifikoval/a:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Datum modifikace:`,
  'ReportSections.newPageButton.txt': () => `Nová stránka`,
  'ReportSections.closeTab.tooltip.txt': () => `Odstranit stránku`,
  'ReportSummaryDialog.title.txt': () => `Souhrn`,
  'ReportSummaryDialog.open.txt': () => `Otevřít`,
  'ReportSummaryDialog.cancel.txt': () => `Zrušit`,
  'ReportSummaryDialog.close.txt': () => `Zavřít`,
  'ReportSummaryDialog.noSummary.txt': () => `Není k dispozici žádný souhrn.`,
  'ReportTileBody.modifiedBy.txt': () => `Modifikoval/a:`,
  'ReportTileBody.lastModified.txt': () => `Poslední modifikace:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Aktualizace reportu`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Automatická aktualizace reportu`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Kontrola aktualizací po tomto počtu minut:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Oznámení výstrah`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Vybrat výchozí oznámení výstrah:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Odeslat e-mailové zprávy`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Odeslat textové zprávy SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Výchozí nastavení správce`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Motivy`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Přepsat motiv reportu a použít motiv reportu SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `Otevírání reportu...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Příprava exportu...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Příprava na tisk...`,
  'PDFGeneration.printingReport.txt': () => `Generování PDF reportu. Po dokončení se stáhne.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} na ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Vyberte akci`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Dosáhli jste nejnižší úrovně hierarchie.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Dosáhli jste nejnižší úrovně všech hierarchií.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Přejít na ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Snímek ${a0} ${a1} v ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Uložit obraz`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Tisk objektu...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Sdílet objekt...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Více`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Nabídka objektu pro ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Zobrazit pomocí SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Přiblížení/oddálení`,
  'ZoomControl.button.zoomin.txt': () => `Přiblížit`,
  'ZoomControl.button.zoomout.txt': () => `Oddálit`,
  'ZoomControl.button.display.txt': () => `Ovládací prvky přiblížení/oddálení`,
  'ZoomControl.button.reset.txt': () => `Resetovat přiblížení/oddálení`,
  'ExpandControl.button.expand.txt': () => `Maximalizovat zobrazení`,
  'ExpandControl.button.restore.txt': () => `Obnovit zobrazení`,
  'ExpandControl.button.expand.tip.txt': () => `Maximalizovat`,
  'ExpandControl.button.restore.tip.txt': () => `Obnovit`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Odkazy stránek nelze provést, když je tento objekt maximalizovaný.`,
  'DragModeControl.button.pan.tip.txt': () => `Posunout`,
  'DragModeControl.button.circular.tip.txt': () => `Kruhový výběr`,
  'DragModeControl.button.freeform.tip.txt': () => `Volný výběr`,
  'DragModeControl.button.rectangular.tip.txt': () => `Obdélníkový výběr`,
  'DragModeControl.button.zoom.tip.txt': () => `Přiblížit/oddálit na obdélník`,
  'ReportXMLDialog.title.txt': () => `XML reportu`,
  'ReportXMLDialog.closeButton.txt': () => `Zavřít`,
  'ReportXMLDialog.copyButton.txt': () => `Kopírovat do schránky`,
  'ReportXMLDialog.error.txt': () => `Chyba načítání XML reportu`,
  'ErrorDialog.error.txt': () => `Došlo k chybě. Obraťte se na správce systému.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics – Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Otevřít report`,
  'OpenReportDialog.reports.txt': () => `Reporty:`,
  'OpenReportDialog.cancel.txt': () => `Zrušit`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objektů aktualizováno`,
  'AriaLive.oneObjectUpdated.txt': () => `1 objekt aktualizován`,
  'AriaLive.reportOpened.txt': () => `Report otevřen`,
  'AriaLive.reportClosed.txt': () => `Report zavřen`,
  'ExportData.generating.txt': () => `Generování exportu. Po dokončení se stáhne.`,
  'ExportData.warning.txt': () => `Chyba při generování dat`,
  'ExportData.nodata.txt': () => `Žádná data k exportu`,
  'ExportData.exportData.txt': () => `Exportovat data...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Uložit`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Zrušit`,
  'PlaybackAnimationDialog.playButton.txt': () => `Přehrát report`,
  'PlaybackAnimationDialog.title.txt': () => `Upravit přehrávání`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Přechodová jednotka:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Stránka`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objekt`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Sekundy na jednotku:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Zobrazit maximalizované objekty:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Zobrazit pouze plochu:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Zobrazit časovač:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Zobrazit navigační ovládací prvky po kliknutí nebo dotyku:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Předchozí stránka`,
  'PlaybackNavigationControls.nextPage.txt': () => `Další stránka`,
  'PlaybackNavigationControls.previousObject.txt': () => `Předchozí objekt`,
  'PlaybackNavigationControls.nextObject.txt': () => `Další objekt`,
  'TransportConnection.generateReportTimeout.txt': () => `Report se načítá dlouho. Chcete pokračovat?`,
  'TransportConnection.openReport.txt': () => `Otevřít report`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Specifikovaný report v následujícím umístění neexistuje: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Rozbalit ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Sbalit ${label}`,
  'GraphElementDecorator.overview.txt': () => `Přehled`,
  'GraphElementDecorator.layers.txt': () => `Skrýt nebo zobrazit vrstvy`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Skrýt přehled`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Zobrazit přehled`,
  'TitleInfoButton.tooltip.txt': () => `Informace`,
  'SectionSelectionBar.noSelections.txt': () => `Žádné výběry`,
  'SectionSelectionBar.title.txt': () => `Filtry:`,
  'CheckboxList.selectAll.txt': () => `Vybrat vše`,
  'CheckboxList.clearSelection.txt': () => `Vymazat výběr`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Vymazat výběr (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Vysvětlení ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Příprava vysvětlení...`,
  'ExplanationInfoDialog.cancel.txt': () => `Zrušit`,
  'ExplanationInfoDialog.close.txt': () => `Zavřít`,
  'PromptHeader.emptyReport.txt': () => `Sem přetáhněte datovou položku nebo ovládací prvek, abyste vytvořili výzvu reportu.`,
  'PromptHeader.emptyPage.txt': () => `Sem přetáhněte datovou položku nebo ovládací prvek, abyste vytvořili výzvu stránky.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Sbalit regulační oblast stránky`,
  'PromptHeader.expandPageControlArea.txt': () => `Rozbalit regulační oblast stránky`,
  'PromptHeader.collapseReportControlArea.txt': () => `Sbalit regulační oblast reportu`,
  'PromptHeader.expandReportControlArea.txt': () => `Rozbalit regulační oblast reportu`,
  'PromptHeader.collapseControlArea.txt': () => `Sbalit regulační oblast`,
  'PromptHeader.expandControlArea.txt': () => `Rozbalit regulační oblast`,
  'PromptHeader.reportControlArea.txt': () => `Regulační oblast reportu`,
  'PromptHeader.allControlAreas.txt': () => `Všechny regulační oblasti`,
  'PromptHeader.pageControlArea.txt': () => `Regulační oblast stránky`,
  'ZeroState.editMode.txt': () => `Sem přetáhněte šablonu, položky dat nebo objekty.`,
  'ZeroState.viewMode.txt': () => `Žádný obsah, který by se dal zobrazit.`,
  'ObjectStatus.assignData.txt': () => `Přiřadit data`,
  'ObjectStatus.selectImage.txt': () => `Vybrat obraz`,
  'ObjectStatus.selectJob.txt': () => `Vybrat úlohu`,
  'ObjectStatus.cancelLoading.txt': () => `Zrušit načítání`,
  'ObjectStatus.loadingCanceled.txt': () => `Načítání zrušeno`,
  'ObjectStatus.resumeLoading.txt': () => `Pokračovat v načítání`,
  'ObjectStatus.refresh.txt': () => `Aktualizovat`,
  'ObjectStatus.setJobParameters.txt': () => `Nastavit hodnoty parametru`,
  'ObjectSearch.title.txt': () => `Geografické hledání`,
  'ObjectSearch.pin.txt': () => `Připnout`,
  'ObjectSearch.unpin.txt': () => `Odepnout`,
  'MainSearchPanel.searchHints.txt': () => `Hledat nápovědy`,
  'MainSearchPanel.searchResults.txt': () => `Výsledky hledání`,
  'MainSearchPanel.features.txt': () => `Funkce`,
  'MainSearchPanel.pin.txt': () => `Nový bod`,
  'MainSearchPanel.pin.tooltip.txt': () => `Nový bod`,
  'MainSearchPanel.route.txt': () => `Nová trasa`,
  'MainSearchPanel.route.tooltip.txt': () => `Nová trasa`,
  'MainSearchPanel.geographicArea.txt': () => `Nová geo. oblast`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Nová geografická oblast`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Bod Moje umístění`,
  'MainSearchPanel.myLocationPin.txt': () => `Moje umístění`,
  'MainSearchPanel.show.txt': () => `Zobrazit`,
  'MainSearchPanel.show.all.txt': () => `Zobrazit vše`,
  'MainSearchPanel.hide.txt': () => `Skrýt`,
  'MainSearchPanel.hide.all.txt': () => `Skrýt vše`,
  'MainSearchPanel.delete.txt': () => `Odstranit`,
  'MainSearchPanel.delete.all.txt': () => `Odstranit vše`,
  'MainSearchPanel.convert.txt': () => `Převést výsledky hledání na body`,
  'MainSearchPanel.convert.all.txt': () => `Převést všechny výsledky hledání na body`,
  'MainSearchPanel.showPinLabels.txt': () => `Zobrazit označení bodů`,
  'MainSearchPanel.close.label.txt': () => `Geografické hledání`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Zobrazit detaily`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografické údaje`,
  'PanelHeader.back.tooltip.txt': () => `Zpět`,
  'GeographicAreaPanel.title.txt': () => `Geografická oblast`,
  'GeographicAreaPanel.draw.txt': () => `Vykreslit oblast`,
  'GeographicAreaPanel.update.txt': () => `Aktualizovat oblast`,
  'GeographicAreaPanel.label.txt': () => `Označení:`,
  'GeographicAreaPanel.location.txt': () => `Umístění:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Vzdálenost (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Vzdálenost (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Přidat vzdálenost`,
  'GeographicAreaPanel.time.add.txt': () => `Přidat čas`,
  'GeographicAreaPanel.distance.delete.txt': () => `Odstranit vzdálenost`,
  'GeographicAreaPanel.time.minutes.txt': () => `Čas (min):`,
  'GeographicAreaPanel.duration.txt': () => `Trvání:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Míle`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometry`,
  'GeographicAreaPanel.menu.clear.txt': () => `Vymazat geografickou oblast`,
  'GeographicAreaPanel.menu.link.txt': () => `Ve výchozím nastavení propojit adresu s datovými prvky a body`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Zrušit propojení adresy geografické oblasti`,
  'GeographicAreaPanel.menu.delete.txt': () => `Odstranit geografickou oblast`,
  'GeographicAreaPanel.demographics.txt': () => `Demografické údaje`,
  'GeographicAreaPanel.demographics.set.txt': () => `Zobrazit demografické údaje`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Rozbalit zobrazení`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Upravit demografické údaje`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Odstranit demografické údaje`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Data demografických údajů se musí znovu načíst`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Znovu načíst demografické údaje`,
  'GeographicAreaPanel.invalid.location.txt': () => `Geografická oblast nemá platné umístění a nelze ji vytvořit.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Vyberte datum a čas`,
  'TravelTypeField.cancel.txt': () => `Zrušit`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Vyberte datum a čas`,
  'TravelTypeField.day.txt': () => `Den:`,
  'TravelTypeField.time.txt': () => `Čas:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Přímo`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Vzdálenost`,
  'TravelTypeField.travelType.txt': () => `Cestovní typ:`,
  'TravelTypeField.traffic.txt': () => `Včetně provozu:`,
  'TravelTypeField.traffic.offset.txt': () => `Časový posun provozu:`,
  'TravelTypeField.traffic.daytime.txt': () => `Datum a čas provozu:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Jednotka vzdálenosti`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Vzdálenost cesty`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Čas cesty`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Vzdálenost dopravy`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Doba dopravy`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Vzdálenost chůze`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Doba chůze`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Ne`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Aktuální provoz`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Typický provoz`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} hod`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Aktualizovat provoz pro tuto funkci`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Aktualizovat provoz pro všechny funkce`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Aktualizovat data o provozu`,
  'RoutePanel.title.txt': () => `Trasa`,
  'RoutePanel.draw.txt': () => `Vykreslit trasu`,
  'RoutePanel.update.txt': () => `Aktualizovat trasu`,
  'RoutePanel.label.txt': () => `Označení:`,
  'RoutePanel.locations.txt': () => `Místa`,
  'RoutePanel.menu.clear.txt': () => `Vymazat trasu`,
  'RoutePanel.menu.reverse.txt': () => `Reverzní trasa`,
  'RoutePanel.menu.add.waypoint.txt': () => `Přidat umístění trasy`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Odstranit umístění trasy`,
  'RoutePanel.menu.unlink.txt': () => `Zrušit propojení umístění trasy`,
  'RoutePanel.menu.arrows.txt': () => `Šipky trasy`,
  'RoutePanel.menu.arrows.hide.txt': () => `Skrýt šipky trasy`,
  'RoutePanel.menu.arrows.show.txt': () => `Skrýt šipky trasy`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Jednosměrné`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Obousměrné`,
  'RoutePanel.menu.delete.txt': () => `Odstranit trasu`,
  'RoutePanel.route.width.txt': () => `Šířka trasy`,
  'RoutePanel.distance.txt': () => `Vzdálenost:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Přidat umístění`,
  'RoutePanel.location.delete.txt': () => `Odstranit umístění`,
  'RoutePanel.duration.txt': () => `Čas:`,
  'RoutePanel.invalid.location.txt': () => `Trasa nemá žádná platná místa a nelze ji vytvořit.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Umístění ${index}, ${location}, zadání`,
  'PinPanel.pinTitle.txt': () => `Připnout`,
  'PinPanel.addDescription.txt': () => `Přidat popis`,
  'PinPanel.deleteDescription.txt': () => `Odstranit popis`,
  'PinPanel.newPin.txt': () => `Nový bod v tomto umístění`,
  'PinPanel.deletePin.txt': () => `Odstranit bod`,
  'PinPanel.linkPins.txt': () => `Ve výchozím nastavení propojit body s datovými prvky`,
  'PinPanel.unlinkAllItems.txt': () => `Zrušit propojení všech položek`,
  'PinPanel.unlinkItems.txt': () => `Zrušit propojení položek`,
  'PinPanel.label.txt': () => `Označení:`,
  'PinPanel.location.txt': () => `Umístění:`,
  'PinPanel.description.txt': () => `Popis:`,
  'PinPanel.linked.txt': () => `PROPOJENO`,
  'PinPanel.searchClickPlaceholder.txt': () => `Vyhledat nebo vybrat na mapě`,
  'PinPanel.searchPlaceholder.txt': () => `Hledat`,
  'PinPanel.addRoute.txt': () => `Přidat trasu`,
  'PinPanel.addRoute.tooltip.txt': () => `Přidat trasu`,
  'PinPanel.addArea.txt': () => `Přidat geo. oblast`,
  'PinPanel.addArea.tooltip.txt': () => `Přidat geografickou oblast`,
  'PinPanel.addArea.title.txt': () => `Přidat geografickou oblast`,
  'PinPanel.myLocationTitle.txt': () => `Bod Moje umístění`,
  'PinPanel.deleteMyLocationPin.txt': () => `Odstranit bod Moje umístění`,
  'PinPanel.enableAutoUpdate.txt': () => `Povolit automatickou aktualizaci Mého umístění`,
  'PinPanel.disableAutoUpdate.txt': () => `Zakázat automatickou aktualizaci Mého umístění`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Upravit interval automatického obnovení Mého umístění`,
  'PinPanel.linkToPin.txt': () => `Odkaz na bod`,
  'PinPanel.useCurrentLocation.txt': () => `Použít aktuální umístění bodu`,
  'PinPanel.notDrawn.txt': () => `Nevykresleno`,
  'PinPanel.undetermined.txt': () => `Neurčeno`,
  'PinPanel.findMyLocation.txt': () => `Najít Moje umístění`,
  'PinPanel.cannotDetermineLocation.txt': () => `Aplikace nemůže určit vaši aktuální polohu. Pokud chcete sdílet svou polohu, podívejte se do nápovědy k prohlížeči nebo zařízení.`,
  'PinPanel.autoRefreshInterval.txt': () => `Interval automatického obnovení Mého umístění`,
  'PinPanel.interval.hours.txt': () => `Hodiny:`,
  'PinPanel.interval.minutes.txt': () => `Minuty:`,
  'PinPanel.interval.seconds.txt': () => `Sekundy:`,
  'PinPanel.invalid.location.txt': () => `Bod nemá platné umístění a nelze ho vytvořit.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min`,
  'PinPanel.clearLocation.tooltip.txt': () => `Vymazat text umístění`,
  'DiscardChangesDialog.title.area.txt': () => `Geografická oblast`,
  'DiscardChangesDialog.title.route.txt': () => `Trasa`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `V geografické oblasti jste provedli změny, ale oblast jste nepřekreslili.\n\nChcete zahodit změny v ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `V geografické trase jste provedli změny, ale trasu jste nepřekreslili.\n\nChcete zahodit změny v ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Zahodit`,
  'DiscardChangesDialog.cancel.txt': () => `Zrušit`,
  'FeatureErrorDialog.title.area.txt': () => `Vykreslit geografickou oblast`,
  'FeatureErrorDialog.title.route.txt': () => `Vykreslit trasu`,
  'FeatureErrorDialog.text.area.txt': () => `Geografickou oblast nelze vykreslit..\n\nTip: Pokud se ve vaší oblasti nenachází cestovní infrastruktura, jako jsou silnice, možná nepůjde geografickou oblast vypočítat. Místo toho použijte typ cesty na delší vzdálenost nebo oblast přesuňte do místa, kde je k dispozici cestovní infrastruktura.`,
  'FeatureErrorDialog.text.route.txt': () => `Trasu nelze vykreslit..\n\nTip: Pokud se na vaší trase nenachází cestovní infrastruktura, jako jsou silnice, možná nepůjde trasu vypočítat. Místo toho použijte typ cesty na delší vzdálenost nebo trasu přesuňte do místa, kde je k dispozici cestovní infrastruktura.`,
  'FeatureErrorDialog.close.txt': () => `Zavřít`,
  'DemographicsSelectorDialog.title.txt': () => `Zobrazit demografické údaje`,
  'DemographicsSelectorDialog.cancel.txt': () => `Zrušit`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Stát/region`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Základní`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Pokročilé`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Poslední`,
  'DemographicsSelectorDialog.categories.txt': () => `Kategorie`,
  'DemographicsSelectorDialog.category.income.txt': () => `Příjem`,
  'DemographicsSelectorDialog.category.age.txt': () => `Věk`,
  'DemographicsSelectorDialog.category.households.txt': () => `Domácnosti`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Bydlení`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Rodinný stav`,
  'DemographicsSelectorDialog.category.population.txt': () => `Populace`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Uživatelská skupina`,
  'DemographicsSelectorDialog.category.health.txt': () => `Zdraví`,
  'DemographicsSelectorDialog.category.education.txt': () => `Vzdělání`,
  'DemographicsSelectorDialog.category.business.txt': () => `Byznys`,
  'DemographicsSelectorDialog.category.race.txt': () => `Rasa`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Výdaje`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Chování`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Úlohy`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Chudoba`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Skladba`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Rizikové`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Klíčová fakta`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Nabídka a poptávka`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Zásada`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Na šířku`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Zločin`,
  'ManageColumns.title.txt': () => `Spravovat sloupce`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Zrušit`,
  'ManageColumns.hiddenColumns.txt': () => `Skryté sloupce`,
  'ManageColumns.displayedColumns.txt': () => `Zobrazené sloupce`,
  'SearchResultPanel.title.txt': () => `Výsledek hledání`,
  'SearchResultPanel.menu.delete.txt': () => `Odstranit výsledek hledání`,
  'SearchResultPanel.convert.txt': () => `Převést na bod`,
  'SearchResultPanel.convert.tooltip.txt': () => `Převést na bod`,
  'DemographicsResultsDialog.title.txt': () => `Demografické údaje`,
  'DemographicsResultsDialog.cancel.txt': () => `Zrušit`,
  'DemographicsResultsDialog.close.txt': () => `Zavřít`,
  'DemographicsResultsDialog.edit.txt': () => `Upravit`,
  'DemographicsResultsDialog.layout.page.txt': () => `Kolotočové zobrazení`,
  'DemographicsResultsDialog.layout.list.txt': () => `Zobrazení jednoho sloupce`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Dlaždicové zobrazení`,
  'DemographicsResultsDialog.noData.txt': () => `Žádné shody dat pro aktuální geografickou oblast.`,
  'PinsAtSameLocationPanel.title.txt': () => `Připnutí ve stejném umístění`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `VÝSLEDKY HLEDÁNÍ`,
  'PinsAtSameLocationPanel.pins.txt': () => `PŘIPNUTÍ`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Zobrazit vše`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Skrýt vše`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Odstranit vše`,
  'PinsAtSameLocationPanel.show.txt': () => `Zobrazit`,
  'PinsAtSameLocationPanel.hide.txt': () => `Skrýt`,
  'PinsAtSameLocationPanel.delete.txt': () => `Odstranit`,
  'LocationPopover.pin.title.txt': () => `Připnout umístění`,
  'LocationPopover.area.title.txt': () => `Umístění geografické oblasti`,
  'LocationPopover.route.title.txt': ({label}) => `Umístění trasy ${label}`,
  'LocationPopover.name.txt': () => `Název`,
  'LocationPopover.location.txt': () => `Umístění:`,
  'LocationPopover.ok.txt': () => `Nastavit umístění`,
  'LocationPopover.cancel.txt': () => `Opustit režim výběru`,
  'LocationPopover.hint.txt': () => `Jiné místo určíte opětovným kliknutím na mapu.`,
  'TreeDualSelector.source.default.txt': () => `Dostupné položky`,
  'TreeDualSelector.target.default.txt': () => `Vybrané položky`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} z ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Žádné položky`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filtr`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Vlastní položka`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} položek přidáno.`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} položek odebráno.`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Všechny položky jsou přidány`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Všechny položky jsou odebrány`,
  'TreeDualSelector.afterAction.up.txt': () => `Přesunuto nahoru`,
  'TreeDualSelector.afterAction.down.txt': () => `Přesunuto dolů`,
  'TreeDualSelector.afterAction.top.txt': () => `Přesunuto zcela nahoru`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Přesunout zcela dolů`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Přidání akce obráceno`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Odebrání akce obráceno`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `vlastní položka přidána`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} vybraná vlastní položka`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `Vybráno ${itemSelected} ${itemDescription}`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} vybráno`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Přesunout o jeden řádek nahoru v ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Přesunout o jeden řádek dolů v ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Přesunout zcela nahoru ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Přesunout zcela dolů ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Přidat položku do ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Přidat vše do ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Odebrat položku z ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Odebrat vše z ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Vzít zpět přidání pro ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Vzít zpět odebrání pro ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filtr ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Odebrat`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Budete-li pokračovat, bude každá vlastní položka, kterou vyberete k odstranění, trvale odstraněna.\n\n Chcete pokračovat?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Odebrat všechny položky`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Budete-li pokračovat, budou vlastní položky na tomto seznamu trvale odstraněny.\n\n Chcete pokračovat?`,
  'LinkNavigator.backButton.label': () => `Zpět`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Příchozí filtry`,
  'LinkNavigator.reportLevel.label': () => `Úroveň reportu`,
  'LinkNavigator.sectionLevel.label': () => `Úroveň stránky`,
  'ReportSectionZeroState.heading.label': () => `Navrhnout report`,
  'ReportSectionZeroState.description.label': () => `Přetáhněte objekty nebo položky dat na stránku nebo vyberte možnost níže.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Přetáhněte objekty nebo datové položky na stránku, nebo začněte od šablony stránky.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Generovat objekt`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Vyberte šablonu`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Prozkoumat návrhy`,
  'PromptContainerTooltip.noSelections.txt': () => `Žádné výběry`,
  'PromptContainerTooltip.selectedValues.txt': () => `Vybrané hodnoty`,
}
export default localizers;
